import Vue from 'vue'

/*
 * En GET, les paramètres de requête passent par `data`, pas par `params` : auth.fetch recompose
 * sa configuration axios à la main et ne recopie pas `params` (voir ExportRepository).
 */

/**
 * Les politiques de recharge d'une organisation : un profil d'usage chacune (« salarié remboursé »,
 * « copropriétaire »…), dont une par défaut. Leurs réglages se lisent et se publient avec ?policyId=.
 */
class ChargingPolicyRepository {

  // GET /api/onboarding/charging-policies/{organizationId}[?archived=1] — la politique par défaut d'abord
  list(organizationId, withArchived = false) {
    return this.fetch({ url: `/api/onboarding/charging-policies/${organizationId}`, method: 'get', data: withArchived ? { archived: 1 } : {} })
  }

  // POST /api/onboarding/charging-policies/{organizationId} — { name, copyFrom? } → { id }
  create(organizationId, name, copyFrom = null) {
    return this.fetch({ url: `/api/onboarding/charging-policies/${organizationId}`, method: 'post', data: { name, copyFrom } })
  }

  // PATCH /api/onboarding/charging-policies/{organizationId}/{policyId} — { name?, default?, archived? }
  update(organizationId, policyId, change) {
    return this.fetch({ url: `/api/onboarding/charging-policies/${organizationId}/${policyId}`, method: 'patch', data: change })
  }

  // DELETE /api/onboarding/charging-policies/{organizationId}/{policyId} — seulement une politique qui n'a jamais servi
  remove(organizationId, policyId) {
    return this.fetch({ url: `/api/onboarding/charging-policies/${organizationId}/${policyId}`, method: 'delete' })
  }

  fetch(options) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch(options)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  }
}

export default new ChargingPolicyRepository()
